// extracted by mini-css-extract-plugin
export var animationContainer = "_pa-0";
export var footer = "_pa-1";
export var gray = "_pa-2";
export var lineItem = "_pa-3";
export var lineItemImage = "_pa-4";
export var lineItemInfo = "_pa-5";
export var lineItemText = "_pa-6";
export var lineItems = "_pa-7";
export var modalContent = "_pa-8";
export var options = "_pa-9";
export var orderName = "_pa-a";
export var refundAmount = "_pa-b";